angular.module('common').controller('FooterController', ['$scope', 'appInfoFactory',
    function ($scope, appInfoFactory) {

        appInfoFactory.getApplicationInfo()
            .success(function (result) {
                $scope.VersionInfo = result;
            })
            .error(function (error) {
                $.message(error.ExceptionMessage, MessageType.Error);
            });
    }
]); 